import { FAVORITE_DELIVERY_TYPE } from 'common/constants';
import { FavoriteAddressState } from 'types/favorite-address';
import { FavoriteDeliveryType } from 'types/checkout-info';
import { TFunction } from 'i18next';

const DELIVERY_TYPE_LABEL_KEYS: Record<
  Exclude<FavoriteDeliveryType, typeof FAVORITE_DELIVERY_TYPE.REGION>,
  | 'header.main.favorite-address.home-delivery'
  | 'header.main.favorite-address.pickup'
  | 'header.main.favorite-address.pickup-point'
> = {
  [FAVORITE_DELIVERY_TYPE.HOME_DELIVERY]: 'header.main.favorite-address.home-delivery',
  [FAVORITE_DELIVERY_TYPE.PICKUP]: 'header.main.favorite-address.pickup',
  [FAVORITE_DELIVERY_TYPE.PICKUP_POINT]: 'header.main.favorite-address.pickup-point',
};

type CityPickerDisplay = {
  label: string;
  regionName: string;
};

type GetCityPickerDisplayParams = {
  enabled: boolean;
  favoriteAddress: FavoriteAddressState;
  regionName: string;
  t: TFunction;
};

export const getCityPickerDisplay = ({
  enabled,
  favoriteAddress,
  regionName,
  t,
}: GetCityPickerDisplayParams): CityPickerDisplay => {
  if (enabled && favoriteAddress.unavailable) {
    return {
      label: t('header.main.region'),
      regionName,
    };
  }

  const hasFavoriteAddressValue =
    !favoriteAddress.unavailable &&
    Boolean(favoriteAddress.address?.deliveryAddress) &&
    favoriteAddress.deliveryType !== FAVORITE_DELIVERY_TYPE.REGION;

  const showFavoriteAddress = enabled && hasFavoriteAddressValue;

  if (showFavoriteAddress) {
    const deliveryType = favoriteAddress.deliveryType as Exclude<
      FavoriteDeliveryType,
      typeof FAVORITE_DELIVERY_TYPE.REGION
    >;

    return {
      label: t(DELIVERY_TYPE_LABEL_KEYS[deliveryType]),
      regionName: favoriteAddress.address!.deliveryAddress!,
    };
  }

  return {
    label: enabled ? t('header.main.favorite-address.region-label') : t('header.main.region'),
    regionName: regionName,
  };
};
